export default function (duration: number) {
  const ms = getMinutesSeconds(duration)
  return `T${ms.minutes}M${ms.seconds}S`
}
